import {inject, injectable} from 'inversify';

import type {FollowerApiModel} from '../../../../api/follower';
import type {IApiDataMapper} from '../../../ports/types';
import type {FollowerModel} from '../Follower.model';

import {FollowerFactory} from '../Follower.factory';
import {FollowerExpandJrpc} from './Follower.expand.jrpc';

@injectable()
export class FollowerMapperJrpc
  implements
    IApiDataMapper<
      FollowerMapperJrpc.ApiData,
      FollowerModel.Props,
      FollowerModel
    >
{
  constructor(
    @inject(FollowerFactory)
    private readonly factory: FollowerFactory,
    @inject(FollowerExpandJrpc)
    public readonly expand: FollowerExpandJrpc,
  ) {}

  mapDataToModel(apiData: FollowerMapperJrpc.ApiData): FollowerModel {
    return this.factory.create(this.mapDataToProps(apiData));
  }

  mapDataToProps(apiData: FollowerMapperJrpc.ApiData): FollowerModel.Props {
    return {
      id: apiData._id,
    };
  }
}

export namespace FollowerMapperJrpc {
  export type ApiData = FollowerApiModel;

  export type ExpandedApiData = ApiData & FollowerExpandJrpc.ExpandedFields;
}
